import { educontSchoolId } from 'Helpers/const/AppData'

export default {
  isSchoolPlatformEducont(state) {
    return state.schoolPlatform?.id === educontSchoolId
  },
}
